module.exports = __webpack_public_path__ + "static/img/b2.346e7ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/b2.jpg
// module id = kZZX
// module chunks = 0